/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

type RightSidebarProps = {
    onClick: (type: string) => void
}

export default function RightSidebar({ onClick }: RightSidebarProps) {
    return (
        <>
            <div id="right-sidebar">
                <div
                    className="sidebar-section"
                    onClick={() => onClick('attack-angle')}
                >
                    <button
                        type="button"
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...({
                            popovertarget: 'question-mark-attack-angle',
                        } as React.HTMLAttributes<HTMLButtonElement>)}
                        className="question-mark"
                    >
                        ?
                    </button>
                </div>
                <div
                    className="sidebar-section"
                    onClick={() => onClick('attack-direction')}
                >
                    <button
                        type="button"
                        popovertarget="question-mark-attack-direction"
                        className="question-mark"
                    >
                        ?
                    </button>
                </div>
                <div
                    className="sidebar-section"
                    onClick={() => onClick('swing-path-tilt')}
                >
                    <button
                        type="button"
                        popovertarget="question-mark-swing-path-tilt"
                        className="question-mark"
                    >
                        ?
                    </button>
                </div>
            </div>
            <div
                id="question-mark-attack-angle"
                popover="auto"
                className="explainer-popover"
            >
                <img
                    src="/sections/leaderboard/images/attack-angle-info.png"
                    alt="attack angle information"
                />
            </div>
            <div
                id="question-mark-attack-direction"
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...({
                    popover: 'auto',
                } as React.HTMLAttributes<HTMLDivElement>)}
                className="explainer-popover"
            >
                <img
                    src="/sections/leaderboard/images/attack-direction-info.jpg"
                    alt="attack direction information"
                />
            </div>
            <div
                id="question-mark-swing-path-tilt"
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...({
                    popover: 'auto',
                } as React.HTMLAttributes<HTMLDivElement>)}
                className="explainer-popover"
            >
                <img
                    src="/sections/leaderboard/images/swing-path-info.jpg"
                    alt="swing path information"
                />
            </div>
        </>
    )
}
